import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { F as FileSaver_minExports } from "./FileSaver.min-CyfCoQbs.mjs";
import { useState, useEffect } from "react";
import { truncateWithEllipsis } from "./utils.mjs";
const Icons = {
  Warning: /* @__PURE__ */ jsx("svg", { width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", fill: "#E41D00", children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.8533 1.46566C11.4849 0.734632 10.5151 0.734632 10.1467 1.46566L0.120058 20.4449C-0.233241 21.146 0.235568 22.0007 0.973373 22.0007H21.0266C21.7644 22.0007 22.2332 21.146 21.8799 20.4449L11.8533 1.46566ZM10.6094 16.1333C10.4883 16.1333 10.3884 16.0974 10.3096 16.0258C10.2309 15.9542 10.1915 15.8632 10.1915 15.753V7.65229C10.1915 7.53105 10.2309 7.43737 10.3096 7.37124C10.3884 7.30512 10.4883 7.27205 10.6094 7.27205H11.3906C11.5118 7.27205 11.6117 7.30787 11.6904 7.37951C11.7691 7.45115 11.8085 7.54207 11.8085 7.65229V15.753C11.8085 15.8632 11.7691 15.9542 11.6904 16.0258C11.6117 16.0974 11.5118 16.1333 11.3906 16.1333H10.6094ZM10.1461 18.7371C10.2248 18.8087 10.3248 18.8445 10.4459 18.8445H11.536C11.6571 18.8445 11.7601 18.8087 11.8448 18.7371C11.9296 18.6654 11.972 18.5745 11.972 18.4643V17.4558C11.972 17.3456 11.9296 17.2547 11.8448 17.1831C11.7601 17.1114 11.6571 17.0756 11.536 17.0756H10.4459C10.3248 17.0756 10.2248 17.1114 10.1461 17.1831C10.0674 17.2547 10.028 17.3456 10.028 17.4558V18.4643C10.028 18.5745 10.0674 18.6654 10.1461 18.7371Z" }) }),
  Shield: /* @__PURE__ */ jsx("svg", { width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", fill: "#E41D00", children: /* @__PURE__ */ jsx("path", { d: "M15.7899 8.8996L10.8739 13.75L7.85241 10.7687L8.95131 9.6845L10.8739 11.5815L14.691 7.81535L15.7899 8.8996ZM11.5347 0.916656L2.95654 3.02499V9.77868C2.95674 12.8055 4.27559 15.6862 6.57727 17.6873L11.5347 22L16.4921 17.6873C18.7938 15.6862 20.1127 12.8055 20.1129 9.77868V3.02499L11.5347 0.916656Z" }) }),
  Grid: /* @__PURE__ */ jsxs("svg", { width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_1435_4757)", children: [
      /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 1.5H1.5V8.5H8.5V1.5ZM0 0V10H10V0H0Z", fill: "#50585F" }),
      /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 1.5H13.5V8.5H20.5V1.5ZM12 0V10H22V0H12Z", fill: "#50585F" }),
      /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 13.5H1.5V20.5H8.5V13.5ZM0 12V22H10V12H0Z", fill: "#50585F" }),
      /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 13.5H13.5V20.5H20.5V13.5ZM12 12V22H22V12H12Z", fill: "#50585F" })
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_1435_4757", children: /* @__PURE__ */ jsx("rect", { width: "22", height: "22", fill: "white" }) }) })
  ] }),
  CircularProgress: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22", children: /* @__PURE__ */ jsx("path", { d: "M11 0.916656C16.5688 0.916656 21.0833 5.43112 21.0833 11C21.0833 16.5688 16.5688 21.0833 11 21.0833C5.43114 21.0833 0.916672 16.5688 0.916672 11H2.59692L2.60069 11.2435C2.7295 15.7715 6.4407 19.4028 11 19.4028C15.6407 19.4028 19.4028 15.6407 19.4028 11C19.4028 6.35957 15.6413 2.5977 11.0009 2.59721L11 0.916656Z" }) }),
  File: /* @__PURE__ */ jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 22.5H20C20.2761 22.5 20.5 22.2761 20.5 22V9.5H16C14.6193 9.5 13.5 8.38071 13.5 7V1.5H4C3.72386 1.5 3.5 1.72386 3.5 2V22C3.5 22.2761 3.72386 22.5 4 22.5ZM4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V8H16C15.4477 8 15 7.55228 15 7V0H4Z" }),
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8356 8.99398L13.8356 0.993976L14.9644 0.00621927L21.9644 8.00622L20.8356 8.99398Z" })
  ] }),
  Download: /* @__PURE__ */ jsx("svg", { width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M17.4166 16.9583C17.7963 16.9583 18.1041 17.2661 18.1041 17.6458C18.1041 17.9939 17.8455 18.2815 17.5099 18.3271L17.4166 18.3333H4.58331C4.20362 18.3333 3.89581 18.0255 3.89581 17.6458C3.89581 17.2978 4.15445 17.0101 4.49002 16.9646L4.58331 16.9583H17.4166ZM11 2.97917C11.348 2.97917 11.6357 3.23781 11.6812 3.57338L11.6875 3.66667V12.8223L14.406 10.1044C14.65 9.86032 15.032 9.83813 15.3011 10.0378L15.3782 10.1044C15.6467 10.3729 15.6467 10.8082 15.3782 11.0767L11.4891 14.9658C11.2207 15.2342 10.7854 15.2342 10.5169 14.9658L6.62778 11.0767C6.3593 10.8082 6.3593 10.3729 6.62778 10.1044C6.89627 9.83591 7.33157 9.83591 7.60005 10.1044L10.3125 12.8168V3.66667C10.3125 3.28698 10.6203 2.97917 11 2.97917Z" }) }),
  Cross: /* @__PURE__ */ jsxs("svg", { width: "22", height: "22", viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_2505_536)", children: /* @__PURE__ */ jsx("path", { d: "M11 0.916656C16.5689 0.916656 21.0834 5.43112 21.0834 11C21.0834 16.5689 16.5689 21.0833 11 21.0833C5.43115 21.0833 0.916687 16.5689 0.916687 11C0.916687 5.43112 5.43115 0.916656 11 0.916656ZM11.0012 2.24481C6.16644 2.24481 2.24713 6.16412 2.24713 10.9988C2.24713 15.8336 6.16644 19.7529 11.0012 19.7529C15.8359 19.7529 19.7552 15.8336 19.7552 10.9988C19.7552 6.16412 15.8359 2.24481 11.0012 2.24481ZM13.6235 7.51231C13.8621 7.27366 14.249 7.27366 14.4877 7.51231C14.7264 7.75097 14.7264 8.1379 14.4877 8.37656L11.8644 11L14.4877 13.6234C14.7025 13.8382 14.724 14.1731 14.5521 14.4119L14.4877 14.4877C14.249 14.7263 13.8621 14.7263 13.6235 14.4877L11 11.8644L8.37659 14.4877C8.1618 14.7025 7.8269 14.7239 7.58809 14.5521L7.51234 14.4877C7.27369 14.249 7.27369 13.8621 7.51234 13.6234L10.1356 11L7.51234 8.37656C7.29756 8.16177 7.27608 7.82687 7.44791 7.58806L7.51234 7.51231C7.751 7.27366 8.13793 7.27366 8.37659 7.51231L11 10.1356L13.6235 7.51231Z" }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2505_536", children: /* @__PURE__ */ jsx("rect", { width: "22", height: "22" }) }) })
  ] })
};
const fileWidget = "file-widget-module_fileWidget_lewYj";
const fileIcon = "file-widget-module_fileIcon_rGwJW";
const fileInfo = "file-widget-module_fileInfo_bWXQO";
const fileNameContainer = "file-widget-module_fileNameContainer_j2HW2";
const fileName = "file-widget-module_fileName_a9joV";
const fileNameLink = "file-widget-module_fileNameLink_vtVWf";
const fileNameTooltip = "file-widget-module_fileNameTooltip_6SMOc";
const visible = "file-widget-module_visible_9LUUA";
const fileType = "file-widget-module_fileType_OjeK5";
const fileDetails = "file-widget-module_fileDetails_qsRWI";
const timestamp = "file-widget-module_timestamp_FviUK";
const errorState = "file-widget-module_errorState_l40o1";
const statusMessage = "file-widget-module_statusMessage_07NOK";
const gridIcon = "file-widget-module_gridIcon_Ivuyh";
const errorIcon = "file-widget-module_errorIcon_MNxiD";
const progressSvg = "file-widget-module_progressSvg_Vlvtk";
const spinnerIcon = "file-widget-module_spinnerIcon_SZ7Rt";
const spin = "file-widget-module_spin_jvv3-";
const cancelButton = "file-widget-module_cancelButton_7X6w5";
const primaryTheme = "file-widget-module_primaryTheme_dQ-g7";
const lightTheme = "file-widget-module_lightTheme_QK-eF";
const downloadIcon = "file-widget-module_downloadIcon_S0S9B";
const screenreaderOnly = "file-widget-module_screenreaderOnly_AxZ8l";
const styles = {
  fileWidget,
  fileIcon,
  fileInfo,
  fileNameContainer,
  fileName,
  fileNameLink,
  fileNameTooltip,
  visible,
  fileType,
  fileDetails,
  timestamp,
  errorState,
  statusMessage,
  gridIcon,
  errorIcon,
  progressSvg,
  spinnerIcon,
  spin,
  cancelButton,
  primaryTheme,
  lightTheme,
  downloadIcon,
  screenreaderOnly
};
const FileWidget = ({
  fileName: fileName2,
  fileType: fileType2,
  timestamp: timestamp2,
  src,
  theme = "light",
  status = "default",
  errorMessage = "Upload failed",
  shouldDownload = true,
  maxFileNameLength = 50,
  maxFileTypeLength = 35,
  onDownload,
  onCancel
}) => {
  const isErrorState = status === "failed" || status === "virus";
  const isReadyToDownloadState = status === "success" || status === "default";
  const [showTooltip, setShowTooltip] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState("");
  useEffect(() => {
    if (downloadStatus) {
      const timer = setTimeout(() => {
        setDownloadStatus("");
      }, 5e3);
      return () => clearTimeout(timer);
    }
  }, [downloadStatus]);
  const isFileNameTruncated = fileName2.length > maxFileNameLength;
  const displayFileName = truncateWithEllipsis(fileName2, maxFileNameLength, 4);
  const displayFileType = truncateWithEllipsis(fileType2, maxFileTypeLength, 0);
  const handleClick = async () => {
    try {
      if (onDownload) {
        await onDownload();
      } else {
        const res = await fetch(src, { cache: "no-store" });
        const blob = await res.blob();
        FileSaver_minExports.saveAs(blob, fileName2);
      }
    } catch (err) {
      console.error(err);
    }
    setDownloadStatus(`File ${fileName2} downloaded`);
  };
  const renderFileName = () => /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles.fileNameContainer,
      "data-testid": "file-name-container",
      onMouseEnter: () => isFileNameTruncated && setShowTooltip(true),
      onMouseLeave: () => setShowTooltip(false),
      children: [
        isReadyToDownloadState ? /* @__PURE__ */ jsx(
          "a",
          {
            href: src,
            target: "_blank",
            rel: "noopener noreferrer",
            className: styles.fileNameLink,
            "aria-label": `${displayFileName} open in new tab`,
            children: displayFileName
          }
        ) : /* @__PURE__ */ jsx("p", { className: styles.fileName, children: displayFileName }),
        isFileNameTruncated && /* @__PURE__ */ jsx(
          "p",
          {
            className: classNames(styles.fileNameTooltip, {
              [styles.visible]: showTooltip
            }),
            role: "tooltip",
            children: fileName2
          }
        )
      ]
    }
  );
  const renderStatusInfo = () => {
    switch (status) {
      case "failed":
        return /* @__PURE__ */ jsx("p", { className: styles.statusMessage, children: errorMessage });
      case "virus":
        return /* @__PURE__ */ jsx("p", { className: styles.statusMessage, children: "Virus detected - File removed" });
      default:
        return /* @__PURE__ */ jsx("p", { className: styles.fileType, children: displayFileType });
    }
  };
  const renderStatusIcon = () => {
    switch (status) {
      case "uploading":
        return /* @__PURE__ */ jsx("div", { className: styles.spinnerIcon, role: "status", "aria-label": "Uploading", children: Icons.CircularProgress });
      case "cancellable":
        return /* @__PURE__ */ jsx("button", { onClick: onCancel, className: styles.cancelButton, "aria-label": "Cancel", children: Icons.Cross });
      case "failed":
        return /* @__PURE__ */ jsx("div", { className: styles.errorIcon, children: Icons.Warning });
      case "virus":
        return /* @__PURE__ */ jsx("div", { className: styles.errorIcon, children: Icons.Shield });
      default:
        return /* @__PURE__ */ jsx("div", { className: styles.gridIcon, children: Icons.Grid });
    }
  };
  if (shouldDownload && isReadyToDownloadState) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { className: styles.screenreaderOnly, "aria-live": "polite", tabIndex: -1, children: downloadStatus }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames(
            styles.fileWidget,
            theme === "primary" ? styles.primaryTheme : styles.lightTheme
          ),
          children: [
            /* @__PURE__ */ jsx("div", { className: styles.fileIcon, children: Icons.File }),
            /* @__PURE__ */ jsxs("div", { className: styles.fileInfo, children: [
              renderFileName(),
              /* @__PURE__ */ jsx("p", { className: styles.fileType, children: displayFileType })
            ] }),
            /* @__PURE__ */ jsxs("div", { className: styles.fileDetails, children: [
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: handleClick,
                  className: styles.downloadIcon,
                  "aria-label": "Download",
                  children: Icons.Download
                }
              ),
              /* @__PURE__ */ jsx("time", { className: styles.timestamp, children: timestamp2 })
            ] })
          ]
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(
        styles.fileWidget,
        { [styles.errorState]: isErrorState },
        !isErrorState && (theme === "primary" ? styles.primaryTheme : styles.lightTheme)
      ),
      children: [
        /* @__PURE__ */ jsx("div", { className: styles.fileIcon, children: Icons.File }),
        /* @__PURE__ */ jsxs("div", { className: styles.fileInfo, children: [
          renderFileName(),
          renderStatusInfo()
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles.fileDetails, children: [
          renderStatusIcon(),
          /* @__PURE__ */ jsx("time", { className: styles.timestamp, children: timestamp2 })
        ] })
      ]
    }
  );
};
export {
  FileWidget as default
};
